/*
 * @Author       : Lobin
 * @Date         : 2020-10-14 14:56:38
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2021-07-29 19:05:31
 */
import { STATION_KEY } from "@/constant";
let tts = undefined;
export const awaitTo = promise => {
  return promise
    .then(res => {
      return [null, res];
    })
    .catch(err => {
      return [err, null];
    });
};
export const playVoiceEnable = () => {
  if(tts === undefined) {
    const stationInfo = JSON.parse(localStorage.getItem(STATION_KEY))
    tts = stationInfo.tts || false;
  }
  return tts;
}
export const playVoice = async message => {
  if(!playVoiceEnable()) {
    return;
  }
  const postData = {
      data: {
        action: 'ttsSpeak',
        value: message
      }
    }
  if(window.plus) {
    uni.postMessage(postData);
  } else {
    window.AndroidBridge.postMessage(JSON.stringify(postData.data));
  }
};
